<template>
  <v-card>
    <v-toolbar card color="white">
      <v-spacer />
      <meta-button type="new" @click="$emit('form')" />
    </v-toolbar>
    <v-divider />
    <v-progress-linear :active="loading" height="3" :indeterminate="true" />
    <v-card-text class="pa-0">
      <v-treeview
        v-if="categoryTree.length"
        :items="categoryTree"
        :load-children="fetchChildren"
        item-text="name"
        open-on-click
        active-class="pruebax"
      >
        <template slot="label" slot-scope="{ item }">
          {{ item.name }}
          <v-icon
            color="primary ripple"
            class="mr-1"
            @click="$emit('form', item.id)"
          >
            add
          </v-icon>
          <v-icon color="success" class="mr-1" @click="setOne(item.id)">
            edit
          </v-icon>
          <v-icon color="primary" class="mr-1" @click="openUpdated(item.id)">
            visibility
          </v-icon>
          <v-icon color="error" @click="ifDelete(item.id)"> delete </v-icon>
        </template>
      </v-treeview>
    </v-card-text>
    <dialog-delete
      :dialog.sync="dialogDelete"
      :loading="loading"
      @delete="_setDelete(idDelete)"
    />
    <dialog-updated-record :dialog.sync="dialogUpdated" :updated="updated" />
  </v-card>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import DialogDelete from '@/components/widgets/dialog/DialogDelete'
import DialogUpdatedRecord from '@/components/widgets/dialog/DialogUpdatedRecord'
import { apiAxios } from '@/helpers'

export default {
  name: 'CategoryList',
  components: { DialogDelete, DialogUpdatedRecord },
  data() {
    return {
      idDelete: '',
      dialogDelete: false,
      dialogUpdated: false,
      categoryTree: [],
    }
  },
  watch: {
    categoryList: {
      handler: function (val) {
        if (val) {
          let parentList = this.categoryList.filter(
            (item) => !item.parentCategory
          )
          this.categoryTree = []
          let vm = this
          setTimeout(() => {
            parentList.forEach((item) =>
              vm.categoryTree.push({
                ...item,
                id: item._id,
                children: item.children ? [] : undefined,
              })
            )
          }, 100)
        }
      },
      deep: true,
      inmediate: true,
    },
  },
  computed: {
    ...mapState({
      categoryList: (state) => state.categories.list,
      loading: (state) => state.categories.loading,
      selected: (state) => state.categories.selected,
    }),
    updated() {
      if (!Array.isArray(this.selected.updated)) return []

      return this.selected.updated
    },
  },
  methods: {
    ...mapActions({
      fetchOne: 'categories/fetchOne',
      setDelete: 'categories/delete',
      reset: 'categories/reset',
    }),
    fetchChildren(item) {
      return apiAxios
        .post(
          'categories/format',
          { parentCategory: item.id, children: true },
          { params: { limit: 0 } }
        )
        .then((result) => {
          if (
            result.data.data &&
            result.data.data.category &&
            result.data.data.category.length
          ) {
            item.children = result.data.data.category.map((element) => ({
              ...element,
              id: element._id,
              children: element.children ? [] : undefined,
            }))
          } else delete item.children
        })
    },
    setOne(id) {
      // this.$emit('clear')
      this.fetchOne(id).then((_) => this.$emit('form'))
    },
    openUpdated(id) {
      this.fetchOne(id).then((_) => (this.dialogUpdated = true))
    },
    ifDelete(id) {
      this.idDelete = id
      this.dialogDelete = true
    },
    _setDelete(id) {
      this.setDelete(id).finally(() => (this.dialogDelete = false))
    },
    emitEvent(evento, id = 0) {
      if (id) {
        this.$emit(evento, id)
      } else {
        this.$emit(evento)
      }
    },
  },
}
</script>
<style lang="scss">
.v-treeview-node__label {
  font-size: 1rem;
  margin-left: 6px;
  flex-grow: 1;
  flex-shrink: 0;
}
.v-treeview-node {
  .v-treeview-node__toggle {
  }
}
</style>
